module.exports = __webpack_public_path__ + "img/Symbol_L2.f9a5825b.png";